/** A new Packing Slip. Nothing is written, and no number spent, until the first Post. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { PACKING_SLIP_FORM } from "@/features/packaging/api";
import { PackingSlipPage } from "@/features/packaging/components/packing-slip-page";

export const Route = createFileRoute("/_app/packaging/packing-slip/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(PACKING_SLIP_FORM))
      throw redirect({ to: "/packaging/packing-slip" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <PackingSlipPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
